(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) {
    root.ZugStickerSharedEngine = api;
    // Compatibility alias for the already-proven V7 integration points.
    root.ZugStickerSharedEngineProof = api;
  }
})(typeof window !== 'undefined' ? window : globalThis, function () {
  'use strict';

  var STRATEGY = 'shared_native_sticker_units';
  var CONTRACT_VERSION = 'shared_native_sticker_units_v1';
  var ACTIVE_MODE = 'shared_native_units';
  var ROLLBACK_MODE = 'component_writer';
  var LAUNCH_DEFERRED_MODE = 'launch_deferred';
  var EXPECTED_RATE_COUNT = 121;
  var activeCatalog = null;
  var activeFamilyCatalogs = {};
  var FAMILY_STRATEGY = 'products2_native_rate_units';
  var FAMILY_CONTRACT_VERSIONS = Object.freeze({
    custom_magnets: 'products2_magnets_native_rates_v1',
    roll_labels: 'products2_roll_labels_native_rates_v1',
    label_sheets: 'products2_label_sheets_native_rates_v1',
    sticker_sheets: 'products2_sticker_sheets_native_rates_v1',
    temp_tattoos: 'products2_temp_tattoos_native_rates_v1'
  });
  var FAMILY_RECIPES = Object.freeze({
    custom_magnets: '',
    roll_labels: 'roll_labels',
    label_sheets: 'label_sheets',
    sticker_sheets: 'sticker_sheets',
    temp_tattoos: 'temp_tattoos'
  });
  var FAMILY_TAGS = Object.freeze({
    custom_magnets: 'ZUG_MAT:magnet',
    roll_labels: 'ZUG_MAT:roll_labels',
    label_sheets: 'ZUG_MAT:label_sheets',
    sticker_sheets: 'ZUG_MAT:sticker_sheets',
    temp_tattoos: 'ZUG_MAT:temp_tattoos'
  });

  // Shopify owns the actual prices. Mutable Shopify IDs are supplied only by
  // the controlled mapping asset; there is intentionally no three-rate
  // fallback in this functional file.
  // Set mode to ROLLBACK_MODE to return the eligible recipe to its existing
  // component writer without changing any other recipe.
  var CONTRACT = Object.freeze({
    version: CONTRACT_VERSION,
    mode: ACTIVE_MODE,
    sourceProductId: 7115979194431,
    carrierProductId: 8285497262143,
    recipeId: '',
    activationTag: 'ZUG_MAT:non_lam',
    materialKey: 'non_lam',
    materialMultiplier: 1.1,
    finish: 'Gloss',
    minimumTotalCents: 1599,
    maximumEncodedQuantity: 200000,
    turnaroundMultipliers: Object.freeze({
      regular: 1,
      rush_3_5: 1.2,
      rush_1_2: 1.5
    }),
    rates: Object.freeze([]),
    monotonicCorrections: Object.freeze([]),
    sizeTiersAreaIn2: Object.freeze([])
  });

  var DIE_CUT_CONTRACT = Object.freeze(Object.assign({}, CONTRACT, {
    mode: ACTIVE_MODE,
    sourceProductId: 4619143774271,
    activationTag: 'ZUG_MAT:die-cut',
    materialKey: 'non_lam',
    materialMultiplier: 1.1,
    finish: 'Gloss'
  }));

  var MATTE_CONTRACT = Object.freeze(Object.assign({}, CONTRACT, {
    mode: ACTIVE_MODE,
    sourceProductId: 7116030148671,
    activationTag: 'ZUG_MAT:matte',
    materialKey: 'matte',
    materialMultiplier: 1.1,
    finish: 'Matte',
    exactMinimumRepresentation: true
  }));

  var CLEAR_CONTRACT = Object.freeze(Object.assign({}, CONTRACT, {
    mode: ACTIVE_MODE,
    sourceProductId: 7111035486271,
    activationTag: 'ZUG_MAT:clear',
    materialKey: 'clear',
    materialMultiplier: 1.7875,
    finish: 'Clear',
    exactMinimumRepresentation: true
  }));

  var HOLOGRAPHIC_CONTRACT = Object.freeze(Object.assign({}, CONTRACT, {
    mode: ACTIVE_MODE,
    sourceProductId: 7112602419263,
    activationTag: 'ZUG_MAT:holographic',
    materialKey: 'holographic',
    materialMultiplier: 2.2,
    finish: 'Holographic',
    exactMinimumRepresentation: true
  }));

  var CHROME_CONTRACT = Object.freeze(Object.assign({}, CONTRACT, {
    mode: ACTIVE_MODE,
    sourceProductId: 7115699290175,
    activationTag: 'ZUG_MAT:chrome',
    materialKey: 'chrome',
    materialMultiplier: 2.2,
    finish: 'Chrome',
    exactMinimumRepresentation: true
  }));

  var SPOT_UV_CONTRACT = Object.freeze(Object.assign({}, CONTRACT, {
    mode: ACTIVE_MODE,
    sourceProductId: 6773442478143,
    activationTag: 'ZUG_MAT:spot_uv',
    materialKey: 'spot_uv',
    materialMultiplier: 1.65,
    finish: 'Raised Spot UV',
    exactMinimumRepresentation: true
  }));

  var WOOD_CONTRACT = Object.freeze(Object.assign({}, CONTRACT, {
    mode: ACTIVE_MODE,
    sourceProductId: 6607083307071,
    activationTag: 'ZUG_MAT:wood',
    materialKey: 'wood',
    materialMultiplier: 3.4375,
    finish: 'Wood',
    exactMinimumRepresentation: true,
    turnaroundMultipliers: Object.freeze({
      regular: 1
    })
  }));

  var WHITE_STATIC_CLING_CONTRACT = Object.freeze(Object.assign({}, CONTRACT, {
    mode: ACTIVE_MODE,
    sourceProductId: 8286752964671,
    activationTag: 'ZUG_MAT:white_static_cling',
    materialKey: 'white_static_cling',
    materialMultiplier: 1.5,
    finish: 'White Static Cling',
    exactMinimumRepresentation: true
  }));

  var CLEAR_STATIC_CLING_CONTRACT = Object.freeze(Object.assign({}, CONTRACT, {
    mode: ACTIVE_MODE,
    sourceProductId: 8286767218751,
    activationTag: 'ZUG_MAT:clear_static_cling',
    materialKey: 'clear_static_cling',
    materialMultiplier: 1.5,
    finish: 'Clear Static Cling',
    exactMinimumRepresentation: true
  }));

  var NON_LAMINATED_CONTRACT = Object.freeze(Object.assign({}, CONTRACT, {
    mode: ACTIVE_MODE,
    sourceProductId: 8289453539391,
    activationTag: 'ZUG_MAT:non_laminated',
    materialKey: 'non_laminated',
    materialMultiplier: 0.88,
    finish: 'Gloss',
    finishOptions: Object.freeze(['Gloss', 'Matte']),
    exactMinimumRepresentation: true
  }));

  var PROFILE_CONTRACTS = Object.freeze({
    gloss: CONTRACT,
    die_cut: DIE_CUT_CONTRACT,
    matte: MATTE_CONTRACT,
    clear: CLEAR_CONTRACT,
    holographic: HOLOGRAPHIC_CONTRACT,
    chrome: CHROME_CONTRACT,
    spot_uv: SPOT_UV_CONTRACT,
    wood: WOOD_CONTRACT,
    non_laminated: NON_LAMINATED_CONTRACT,
    white_static_cling: WHITE_STATIC_CLING_CONTRACT,
    clear_static_cling: CLEAR_STATIC_CLING_CONTRACT
  });

  function positiveInteger(value) {
    var number = Number(value);
    return Number.isInteger(number) && number > 0 ? number : null;
  }

  function moneyCents(value) {
    var number = Number(value);
    return Number.isFinite(number) ? Math.round(number * 100) : null;
  }

  function exactActivation(activation, contract) {
    activation = activation || {};
    var contractFinishOptions = Array.isArray(contract.finishOptions)
      ? contract.finishOptions
      : [contract.finish];
    var activationFinishOptions = Array.isArray(activation.finishOptions)
      ? activation.finishOptions
      : [activation.finish];
    return Number(activation.sourceProductId) === contract.sourceProductId &&
      String(activation.recipeId || '') === contract.recipeId &&
      String(activation.activationTag || '') === contract.activationTag &&
      String(activation.materialKey || '') === contract.materialKey &&
      Number(activation.materialMultiplier) === contract.materialMultiplier &&
      activation.laminationEnabled === false &&
      String(activation.lamination || '') === 'non_lam' &&
      activationFinishOptions.join('|') === contractFinishOptions.join('|');
  }

  function validateCatalog(catalog) {
    if (!catalog || catalog.schemaVersion !== 1 ||
        catalog.status !== 'production_standard_vinyl' ||
        catalog.contractVersion !== CONTRACT_VERSION ||
        !catalog.sharedProduct ||
        Number(catalog.sharedProduct.productId) !== CONTRACT.carrierProductId ||
        String(catalog.sharedProduct.status || '') !== 'UNLISTED' ||
        !exactActivation(catalog.activation, CONTRACT)) {
      throw new Error('Shared Sticker production catalog identity is invalid.');
    }
    var activationProfiles = catalog.activationProfiles || {};
    var activationProfileKeys = Object.keys(activationProfiles).sort();
    if (activationProfileKeys.join('|') !==
          'chrome|clear|clear_static_cling|die_cut|gloss|holographic|matte|non_laminated|spot_uv|white_static_cling|wood' ||
        !exactActivation(activationProfiles.gloss, CONTRACT) ||
        !exactActivation(activationProfiles.die_cut, DIE_CUT_CONTRACT) ||
        !exactActivation(activationProfiles.matte, MATTE_CONTRACT) ||
        !exactActivation(activationProfiles.clear, CLEAR_CONTRACT) ||
        !exactActivation(
          activationProfiles.holographic,
          HOLOGRAPHIC_CONTRACT
        ) ||
        !exactActivation(activationProfiles.chrome, CHROME_CONTRACT) ||
        !exactActivation(activationProfiles.spot_uv, SPOT_UV_CONTRACT) ||
        !exactActivation(activationProfiles.wood, WOOD_CONTRACT) ||
        !exactActivation(
          activationProfiles.non_laminated,
          NON_LAMINATED_CONTRACT
        ) ||
        !exactActivation(
          activationProfiles.white_static_cling,
          WHITE_STATIC_CLING_CONTRACT
        ) ||
        !exactActivation(
          activationProfiles.clear_static_cling,
          CLEAR_STATIC_CLING_CONTRACT
        )) {
      throw new Error('Shared Sticker production activation profiles are invalid.');
    }
    var catalogContract = catalog.contract || {};
    if (Number(catalogContract.rateCount) !== EXPECTED_RATE_COUNT ||
        Number(catalogContract.minimumTotalCents) !== CONTRACT.minimumTotalCents ||
        Number(catalogContract.maximumEncodedQuantity) !==
          CONTRACT.maximumEncodedQuantity ||
        catalogContract.hiddenDollarCentFallback !== false) {
      throw new Error('Shared Sticker production catalog contract is invalid.');
    }
    var generatedFrom = catalog.generatedFrom || {};
    if (generatedFrom.ratesArtifactSha256 !==
          'ce7991a6d57fad9a9a25eff3fc2412b2ad3da1070757cffd965cfa38805bc177' ||
        generatedFrom.productionAuditSha256 !==
          'cb32c39f4fe225c7da8e2ee2b458e5f2d2dbf38abd4398732a6df0c7a7581adb' ||
        generatedFrom.normalizedStateStreamSha256 !==
          'ae84b87d7583edc81e68c0711e261579ff8d8a10a9fb053dea22600f6ef9ba82') {
      throw new Error('Shared Sticker production catalog evidence is invalid.');
    }
    var turnarounds = catalogContract.turnaroundMultipliers || {};
    if (Number(turnarounds.regular) !== 1 ||
        Number(turnarounds.rush_3_5) !== 1.2 ||
        Number(turnarounds.rush_1_2) !== 1.5) {
      throw new Error('Shared Sticker production turnaround catalog is invalid.');
    }

    var rates = Array.isArray(catalog.rates) ? catalog.rates : [];
    var rateKeys = {};
    var rateCents = {};
    var variantIds = {};
    var variantIdByRateCents = {};
    var skus = {};
    var forbiddenVariantIds = {
      43634000035903: true,
      43634000068671: true,
      42847865045055: true,
      42847865077823: true
    };
    if (rates.length !== EXPECTED_RATE_COUNT) {
      throw new Error('Shared Sticker production catalog must map 121 rates.');
    }
    rates.forEach(function (entry) {
      var cents = positiveInteger(entry.rateCents);
      var variantId = positiveInteger(entry.variantId);
      var key = String(entry.rateKey || '');
      var sku = String(entry.sku || '');
      if (!/^rate_\d{4}c$/.test(key) || !cents || !variantId || !sku ||
          rateKeys[key] || rateCents[cents] || variantIds[variantId] || skus[sku] ||
          forbiddenVariantIds[variantId]) {
        throw new Error('Shared Sticker production catalog has a duplicate or invalid rate.');
      }
      rateKeys[key] = true;
      rateCents[cents] = true;
      variantIds[variantId] = true;
      variantIdByRateCents[cents] = variantId;
      skus[sku] = true;
    });

    var correctionsByProfile = catalog.monotonicCorrectionsByProfile || {};
    var expectedCorrectionCounts = {
      gloss: 0,
      die_cut: 0,
      matte: 0,
      clear: 1,
      holographic: 0,
      chrome: 0,
      static_cling: 0,
      white_static_cling: 0,
      clear_static_cling: 0,
      spot_uv: 0,
      wood: 0,
      non_laminated: 1
    };
    if (Object.keys(correctionsByProfile).sort().join('|') !==
        Object.keys(expectedCorrectionCounts).sort().join('|')) {
      throw new Error('Shared Sticker production correction profiles are incomplete.');
    }
    Object.keys(expectedCorrectionCounts).forEach(function (profileKey) {
      var corrections = Array.isArray(correctionsByProfile[profileKey])
        ? correctionsByProfile[profileKey]
        : [];
      var correctionKeys = {};
      if (corrections.length !== expectedCorrectionCounts[profileKey]) {
        throw new Error('Shared Sticker production correction catalog is incomplete.');
      }
      corrections.forEach(function (row) {
        var key = String(row.key || '');
        var expectedKey = [row.sizeTierIn2, row.pieces, row.turnaround].join('|');
        var correctedRateCents = Number(
          row.correctedRateCents || row.originalRateCents
        );
        var correctedVariantId = Number(
          row.correctedVariantId || variantIdByRateCents[correctedRateCents]
        );
        if (!key || key !== expectedKey || correctionKeys[key] ||
            !rateCents[row.originalRateCents] ||
            !rateCents[correctedRateCents] ||
            correctedVariantId !== variantIdByRateCents[correctedRateCents] ||
            !positiveInteger(row.originalEncodedQuantity) ||
            !positiveInteger(row.correctedEncodedQuantity) ||
            Number(row.originalNativeTotalCents) !==
              Number(row.originalRateCents) * Number(row.originalEncodedQuantity) ||
            Number(row.correctedNativeTotalCents) !==
              correctedRateCents * Number(row.correctedEncodedQuantity)) {
          throw new Error('Shared Sticker production monotonic correction is invalid.');
        }
        correctionKeys[key] = true;
      });
    });

    var sizeTiers = catalogContract.sizeTiersAreaIn2 || [];
    if (!Array.isArray(sizeTiers) || !sizeTiers.length) {
      throw new Error('Shared Sticker production size-tier contract is missing.');
    }
    return {
      activationProfiles: {
        gloss: Object.assign({}, activationProfiles.gloss),
        die_cut: Object.assign({}, activationProfiles.die_cut),
        matte: Object.assign({}, activationProfiles.matte),
        clear: Object.assign({}, activationProfiles.clear),
        holographic: Object.assign({}, activationProfiles.holographic),
        chrome: Object.assign({}, activationProfiles.chrome),
        spot_uv: Object.assign({}, activationProfiles.spot_uv),
        wood: Object.assign({}, activationProfiles.wood),
        non_laminated: Object.assign({}, activationProfiles.non_laminated),
        white_static_cling: Object.assign(
          {}, activationProfiles.white_static_cling
        ),
        clear_static_cling: Object.assign(
          {}, activationProfiles.clear_static_cling
        )
      },
      rates: rates.map(function (entry) {
        return {
          rateKey: String(entry.rateKey),
          rateCents: Number(entry.rateCents),
          variantId: Number(entry.variantId),
          sku: String(entry.sku),
          title: String(entry.title || '')
        };
      }),
      monotonicCorrectionsByProfile: Object.keys(correctionsByProfile).reduce(
        function (copy, profileKey) {
          copy[profileKey] = correctionsByProfile[profileKey].map(function (row) {
            return Object.assign({}, row);
          });
          return copy;
        },
        {}
      ),
      sizeTiersAreaIn2: sizeTiers.map(Number)
    };
  }

  function configureCatalog(catalog) {
    activeCatalog = validateCatalog(catalog);
    return getContract();
  }

  function validateFamilyCatalog(catalog) {
    var family = String(catalog && catalog.family || '');
    var expectedVersion = FAMILY_CONTRACT_VERSIONS[family];
    var expectedMaximumEncodedQuantity = family === 'temp_tattoos'
      ? 370000
      : 200000;
    var products = catalog && Array.isArray(catalog.products)
      ? catalog.products
      : [];
    if (!expectedVersion || catalog.schemaVersion !== 1 ||
        catalog.status !== 'production_products2_native_rates' ||
        catalog.contractVersion !== expectedVersion ||
        !catalog.contract || Number(catalog.contract.rateCount) !== EXPECTED_RATE_COUNT ||
        Number(catalog.contract.maximumEncodedQuantity) !==
          expectedMaximumEncodedQuantity ||
        catalog.contract.hiddenDollarCentFallback !== false ||
        catalog.contract.customerInputsRemainDynamic !== true ||
        ((family === 'sticker_sheets' || family === 'temp_tattoos') &&
          catalog.contract.exactRepresentationsOnly !== true) ||
        !products.length) {
      throw new Error('Products 2.0 native-rate catalog contract is invalid.');
    }

    var productIds = {};
    var variantIds = {};
    products.forEach(function (product) {
      var productId = positiveInteger(product.productId);
      var rates = Array.isArray(product.rates) ? product.rates : [];
      var activationTag = String(product.activationTag || '');
      var requiredTags = Array.isArray(product.requiredTags) && product.requiredTags.length
        ? product.requiredTags.map(function (tag) { return String(tag); })
        : [activationTag];
      var rateCents = {};
      var skus = {};
      if (!productId || productIds[productId] || !product.title || !product.handle ||
          activationTag !== FAMILY_TAGS[family] ||
          !requiredTags.length || requiredTags.some(function (tag, index) {
            return !tag || requiredTags.indexOf(tag) !== index;
          }) || requiredTags.indexOf(activationTag) === -1 ||
          rates.length !== EXPECTED_RATE_COUNT) {
        throw new Error('Products 2.0 native-rate product identity is invalid.');
      }
      productIds[productId] = true;
      rates.forEach(function (rate) {
        var cents = positiveInteger(rate.rateCents);
        var variantId = positiveInteger(rate.variantId);
        var sku = String(rate.sku || '');
        if (!cents || !variantId || !sku || rateCents[cents] ||
            variantIds[variantId] || skus[sku] ||
            !/^rate_\d{4}c$/.test(String(rate.rateKey || ''))) {
          throw new Error('Products 2.0 native-rate mapping is invalid or duplicated.');
        }
        rateCents[cents] = true;
        variantIds[variantId] = true;
        skus[sku] = true;
      });
    });

    return {
      family: family,
      contractVersion: expectedVersion,
      maximumEncodedQuantity: expectedMaximumEncodedQuantity,
      exactRepresentationsOnly:
        catalog.contract.exactRepresentationsOnly === true,
      products: products.map(function (product) {
        var activationTag = String(product.activationTag);
        var requiredTags = Array.isArray(product.requiredTags) && product.requiredTags.length
          ? product.requiredTags.map(function (tag) { return String(tag); })
          : [activationTag];
        return {
          productId: Number(product.productId),
          title: String(product.title),
          handle: String(product.handle),
          template: product.template == null ? null : String(product.template),
          activationTag: activationTag,
          requiredTags: requiredTags,
          rates: product.rates.map(function (rate) {
            return {
              rateKey: String(rate.rateKey),
              rateCents: Number(rate.rateCents),
              variantId: Number(rate.variantId),
              sku: String(rate.sku),
              title: String(rate.title || '')
            };
          })
        };
      })
    };
  }

  function configureFamilyCatalog(catalog) {
    var validated = validateFamilyCatalog(catalog);
    activeFamilyCatalogs[validated.family] = validated;
    return validated;
  }

  function getFamilyContract(productId) {
    productId = Number(productId);
    var familyKey = Object.keys(activeFamilyCatalogs).filter(function (key) {
      return activeFamilyCatalogs[key].products.some(function (product) {
        return product.productId === productId;
      });
    })[0] || '';
    if (!familyKey) return null;
    var catalog = activeFamilyCatalogs[familyKey];
    var product = catalog.products.filter(function (entry) {
      return entry.productId === productId;
    })[0];
    return {
      version: catalog.contractVersion,
      mode: ACTIVE_MODE,
      strategy: FAMILY_STRATEGY,
      family: familyKey,
      profileKey: familyKey,
      sourceProductId: product.productId,
      carrierProductId: product.productId,
      recipeId: FAMILY_RECIPES[familyKey],
      activationTag: FAMILY_TAGS[familyKey],
      requiredTags: product.requiredTags.slice(),
      maximumEncodedQuantity: catalog.maximumEncodedQuantity,
      exactRepresentationsOnly: catalog.exactRepresentationsOnly,
      rates: product.rates
    };
  }

  function classifyFamily(input) {
    input = input || {};
    var productId = Number(input.productId);
    var knownFamily = Object.keys(FAMILY_CONTRACT_VERSIONS).filter(function (family) {
      var catalog = activeFamilyCatalogs[family];
      return catalog && catalog.products.some(function (product) {
        return product.productId === productId;
      });
    })[0] || '';
    if (!knownFamily) {
      var eligibleFamily = productId === 4654188494911 || productId === 8495452848191
        ? 'custom_magnets'
        : tagsContain(input.tags, FAMILY_TAGS.roll_labels)
          ? 'roll_labels'
          : tagsContain(input.tags, FAMILY_TAGS.label_sheets)
            ? 'label_sheets'
            : tagsContain(input.tags, FAMILY_TAGS.sticker_sheets)
              ? 'sticker_sheets'
              : tagsContain(input.tags, FAMILY_TAGS.temp_tattoos)
                ? 'temp_tattoos'
                : '';
      return eligibleFamily
        ? { eligible: true, active: false, reason: 'catalog_unavailable', family: eligibleFamily }
        : { eligible: false, active: false, reason: 'different_product' };
    }
    var contract = getFamilyContract(productId);
    var exact = !!contract &&
      contract.requiredTags.every(function (tag) { return tagsContain(input.tags, tag); }) &&
      String(input.recipeId || '') === contract.recipeId;
    if (knownFamily === 'custom_magnets') {
      exact = exact && String(input.materialKey || '') === 'magnet';
    }
    return exact
      ? { eligible: true, active: true, reason: 'active', family: knownFamily, profileKey: knownFamily, productId: productId }
      : { eligible: true, active: false, reason: 'activation_contract_mismatch', family: knownFamily, productId: productId };
  }

  function getContract(profileKey) {
    if (!activeCatalog) return null;
    profileKey = String(profileKey || 'gloss');
    var profileContract = PROFILE_CONTRACTS[profileKey];
    if (!profileContract || !activeCatalog.activationProfiles[profileKey]) return null;
    return Object.assign({}, profileContract, {
      profileKey: profileKey,
      rates: activeCatalog.rates,
      monotonicCorrections:
        activeCatalog.monotonicCorrectionsByProfile[profileKey] || [],
      sizeTiersAreaIn2: activeCatalog.sizeTiersAreaIn2
    });
  }

  function clearCatalogForTest() {
    activeCatalog = null;
  }

  function clearFamilyCatalogsForTest() {
    activeFamilyCatalogs = {};
  }

  function copyProperties(properties) {
    var copy = {};
    Object.keys(properties || {}).forEach(function (key) {
      copy[key] = properties[key];
    });
    return copy;
  }

  function tagsContain(tags, expected) {
    return Array.isArray(tags) && tags.some(function (tag) {
      return String(tag || '') === expected;
    });
  }

  function classify(input, contract) {
    var explicitContract = !!contract;
    input = input || {};
    var profileKey = contract && contract.profileKey || '';
    if (!contract) {
      profileKey = Object.keys(PROFILE_CONTRACTS).filter(function (key) {
        return Number(input.productId) ===
          Number(PROFILE_CONTRACTS[key].sourceProductId);
      })[0] || '';
      contract = PROFILE_CONTRACTS[profileKey] || CONTRACT;
    }

    var sourceProductMatches =
      Number(input.productId) === Number(contract.sourceProductId);
    if (!sourceProductMatches) {
      return { eligible: false, active: false, reason: 'different_product' };
    }
    if (contract.mode === ROLLBACK_MODE) {
      return { eligible: false, active: false, reason: 'rollback_mode' };
    }
    if (contract.mode === LAUNCH_DEFERRED_MODE) {
      return {
        eligible: true,
        active: false,
        reason: 'launch_deferred',
        profileKey: profileKey
      };
    }
    if (contract.mode !== ACTIVE_MODE) {
      return { eligible: true, active: false, reason: 'invalid_mode' };
    }

    var exact = String(input.recipeId || '') === contract.recipeId &&
      tagsContain(input.tags, contract.activationTag) &&
      String(input.materialKey || '') === contract.materialKey &&
      Number(input.materialMultiplier) === contract.materialMultiplier &&
      input.laminationEnabled === false &&
      String(input.lamination || 'non_lam') === 'non_lam';

    if (exact && Array.isArray(contract.finishOptions)) {
      exact = contract.finishOptions.indexOf(String(input.finish || '')) !== -1;
    }

    if (!exact) {
      return {
        eligible: false,
        active: false,
        reason: 'activation_contract_mismatch'
      };
    }
    if (!explicitContract && !activeCatalog) {
      return {
        eligible: true,
        active: false,
        reason: 'catalog_unavailable',
        profileKey: profileKey
      };
    }
    if (!explicitContract && !activeCatalog.activationProfiles[profileKey]) {
      return {
        eligible: true,
        active: false,
        reason: 'catalog_unavailable',
        profileKey: profileKey
      };
    }
    return {
      eligible: true,
      active: true,
      reason: 'active',
      profileKey: profileKey
    };
  }

  function rateMap(contract) {
    var mapping = {};
    (contract.rates || []).forEach(function (entry) {
      var rateCents = positiveInteger(entry.rateCents);
      var variantId = positiveInteger(entry.variantId);
      if (!rateCents || !variantId || mapping[rateCents]) {
        throw new Error('Invalid or duplicate shared Sticker production rate mapping.');
      }
      mapping[rateCents] = {
        rateCents: rateCents,
        variantId: variantId,
        sku: String(entry.sku || '')
      };
    });
    return mapping;
  }

  function validatePricingInput(input, contract) {
    var pricing = input && input.pricing;
    if (!pricing) throw new Error('Shared Sticker production pricing is missing.');

    var pieces = positiveInteger(pricing.qty_entered);
    var sizeTier = Number(pricing.size_tier_in2);
    var qLow = positiveInteger(pricing.q_low);
    var qHigh = positiveInteger(pricing.q_high);
    var lowRateCents = moneyCents(pricing.u_low);
    var highRateCents = moneyCents(pricing.u_high);
    var turnaround = String(pricing.rush_option || 'regular');
    var turnaroundMultiplier = contract.turnaroundMultipliers[turnaround];
    var materialMultiplier = Number(pricing.material_mult);
    var globalBaseScalar = Number(pricing.global_base_scalar || 1);

    if (!pieces || !qLow || !qHigh || qLow > pieces || pieces > qHigh ||
        !lowRateCents || !highRateCents) {
      throw new Error('Shared Sticker production pricing bounds are invalid.');
    }
    if (!Number.isFinite(sizeTier) ||
        contract.sizeTiersAreaIn2.indexOf(sizeTier) === -1) {
      throw new Error('Shared Sticker production size tier is unsupported.');
    }
    if (!Number.isFinite(turnaroundMultiplier) || turnaroundMultiplier <= 0) {
      throw new Error('Shared Sticker production turnaround is unsupported.');
    }
    if (pricing.rush_mult != null &&
        Number(pricing.rush_mult) !== turnaroundMultiplier) {
      throw new Error('Shared Sticker production turnaround multiplier is invalid.');
    }
    if (materialMultiplier !== contract.materialMultiplier ||
        String(pricing.material_key || '') !== contract.materialKey) {
      throw new Error('Shared Sticker production material contract is invalid.');
    }
    if (globalBaseScalar !== 1) {
      throw new Error('Shared Sticker production base scalar is unsupported.');
    }

    return {
      pieces: pieces,
      sizeTier: sizeTier,
      qLow: qLow,
      qHigh: qHigh,
      lowRateCents: lowRateCents,
      highRateCents: highRateCents,
      turnaround: turnaround,
      turnaroundMultiplier: turnaroundMultiplier,
      materialMultiplier: materialMultiplier
    };
  }

  function interpolationFraction(pieces, qLow, qHigh) {
    return qLow === qHigh ? 0 : (pieces - qLow) / (qHigh - qLow);
  }

  function candidateForRate(state, mapping, pieces, contract) {
    var t = interpolationFraction(pieces, state.qLow, state.qHigh);
    var lowUnitsPerPiece = state.lowRateCents / mapping.rateCents;
    var highUnitsPerPiece = state.highRateCents / mapping.rateCents;
    var interpolatedUnitsPerPiece = lowUnitsPerPiece +
      t * (highUnitsPerPiece - lowUnitsPerPiece);
    var unroundedEncodedQuantity = interpolatedUnitsPerPiece * pieces *
      state.materialMultiplier * state.turnaroundMultiplier;
    var encodedQuantity = Math.max(
      Math.round(unroundedEncodedQuantity),
      Math.ceil(contract.minimumTotalCents / mapping.rateCents)
    );

    return {
      rateCents: mapping.rateCents,
      variantId: mapping.variantId,
      sku: mapping.sku,
      encodedQuantity: encodedQuantity,
      unroundedEncodedQuantity: unroundedEncodedQuantity,
      nativeTotalCents: mapping.rateCents * encodedQuantity
    };
  }

  function selectCandidate(state, pieces, mappings, contract) {
    var t = interpolationFraction(pieces, state.qLow, state.qHigh);
    var interpolatedRateCents = state.lowRateCents +
      t * (state.highRateCents - state.lowRateCents);
    var currentV2TotalCents = Math.round(Math.max(
      interpolatedRateCents * pieces * state.materialMultiplier *
        state.turnaroundMultiplier,
      contract.minimumTotalCents
    ));
    var candidates = mappings.map(function (mapping) {
      var candidate = candidateForRate(state, mapping, pieces, contract);
      candidate.differenceFromV2Cents =
        candidate.nativeTotalCents - currentV2TotalCents;
      return candidate;
    });

    candidates.sort(function (left, right) {
      var error = Math.abs(left.differenceFromV2Cents) -
        Math.abs(right.differenceFromV2Cents);
      if (error !== 0) return error;
      if (left.rateCents !== right.rateCents) {
        return right.rateCents - left.rateCents;
      }
      return left.encodedQuantity - right.encodedQuantity;
    });

    var selected = candidates[0];
    selected.currentV2TotalCents = currentV2TotalCents;
    selected.interpolationFraction = t;
    return selected;
  }

  function selectExactMinimumCandidate(state, pieces, mappingsByRate, contract) {
    var candidates = Object.keys(mappingsByRate).map(function (rateCents) {
      return candidateForRate(
        state,
        mappingsByRate[rateCents],
        pieces,
        contract
      );
    }).filter(function (candidate) {
      return candidate.nativeTotalCents === contract.minimumTotalCents;
    });

    candidates.sort(function (left, right) {
      if (left.encodedQuantity !== right.encodedQuantity) {
        return left.encodedQuantity - right.encodedQuantity;
      }
      return right.rateCents - left.rateCents;
    });

    if (!candidates.length) return null;
    var selected = candidates[0];
    selected.currentV2TotalCents = contract.minimumTotalCents;
    selected.differenceFromV2Cents = 0;
    selected.interpolationFraction = interpolationFraction(
      pieces,
      state.qLow,
      state.qHigh
    );
    selected.exactMinimumRepresentationApplied = true;
    return selected;
  }

  function applyMonotonicCorrection(state, selected, contract) {
    var correctionKey = [state.sizeTier, state.pieces, state.turnaround].join('|');
    var correction = null;
    (contract.monotonicCorrections || []).some(function (row) {
      if (String(row.key) !== correctionKey) return false;
      correction = row;
      return true;
    });
    if (!correction) {
      selected.monotonicCorrectionApplied = false;
      return selected;
    }
    if (Number(correction.originalRateCents) !== selected.rateCents ||
        Number(correction.originalEncodedQuantity) !== selected.encodedQuantity ||
        Number(correction.originalNativeTotalCents) !== selected.nativeTotalCents) {
      throw new Error('Shared Sticker production correction input mismatch.');
    }
    var correctedRateCents = Number(
      correction.correctedRateCents || correction.originalRateCents
    );
    var correctedMapping = rateMap(contract)[correctedRateCents];
    if (!correctedMapping || (correction.correctedVariantId &&
        Number(correction.correctedVariantId) !== correctedMapping.variantId)) {
      throw new Error('Shared Sticker production correction mapping mismatch.');
    }
    selected.encodedQuantity = Number(correction.correctedEncodedQuantity);
    selected.rateCents = correctedRateCents;
    selected.variantId = correctedMapping.variantId;
    selected.sku = correctedMapping.sku;
    selected.nativeTotalCents = Number(correction.correctedNativeTotalCents);
    selected.differenceFromV2Cents =
      selected.nativeTotalCents - selected.currentV2TotalCents;
    selected.monotonicCorrectionApplied = true;
    selected.monotonicFloorCents = Number(correction.monotonicFloorCents);
    return selected;
  }

  function resolve(input, contract) {
    contract = contract || getContract(input && input.profileKey);
    if (!contract) {
      throw new Error('Shared Sticker production catalog is unavailable.');
    }
    var state = validatePricingInput(input, contract);
    var mappingsByRate = rateMap(contract);
    var adjacentRates = state.lowRateCents === state.highRateCents
      ? [state.lowRateCents]
      : [state.lowRateCents, state.highRateCents];
    var mappings = adjacentRates.map(function (rateCents) {
      var mapping = mappingsByRate[rateCents];
      if (!mapping) {
        throw new Error(
          'Shared Sticker production rate ' + rateCents + ' cents is unsupported.'
        );
      }
      return mapping;
    });

    var selected = selectCandidate(state, state.pieces, mappings, contract);
    if (contract.exactMinimumRepresentation === true &&
        selected.currentV2TotalCents === contract.minimumTotalCents) {
      selected = selectExactMinimumCandidate(
        state,
        state.pieces,
        mappingsByRate,
        contract
      ) || selected;
    }
    if (selected.exactMinimumRepresentationApplied) {
      selected.monotonicCorrectionApplied = false;
    } else {
      selected = applyMonotonicCorrection(state, selected, contract);
    }
    if (!positiveInteger(selected.encodedQuantity) ||
        selected.encodedQuantity > contract.maximumEncodedQuantity) {
      throw new Error('Shared Sticker production encoded quantity is invalid.');
    }
    if (selected.nativeTotalCents < contract.minimumTotalCents ||
        selected.nativeTotalCents !==
          selected.rateCents * selected.encodedQuantity) {
      throw new Error('Shared Sticker production native total cannot be reconciled.');
    }

    var selectedFinish = contract.finish;
    if (Array.isArray(contract.finishOptions)) {
      selectedFinish = String(
        input && (input.finish || input.activation && input.activation.finish) || ''
      );
      if (contract.finishOptions.indexOf(selectedFinish) === -1) {
        throw new Error('Shared Sticker production finish is unsupported.');
      }
    }

    return {
      profileKey: contract.profileKey || '',
      contractVersion: contract.version,
      carrierProductId: contract.carrierProductId,
      variantId: selected.variantId,
      sku: selected.sku,
      rateCents: selected.rateCents,
      encodedQuantity: selected.encodedQuantity,
      unroundedEncodedQuantity: selected.unroundedEncodedQuantity,
      nativeTotalCents: selected.nativeTotalCents,
      currentV2TotalCents: selected.currentV2TotalCents,
      differenceFromV2Cents: selected.differenceFromV2Cents,
      exactMinimumRepresentationApplied:
        !!selected.exactMinimumRepresentationApplied,
      monotonicCorrectionApplied: !!selected.monotonicCorrectionApplied,
      monotonicFloorCents: selected.monotonicFloorCents || null,
      pieces: state.pieces,
      sizeTierIn2: state.sizeTier,
      turnaround: state.turnaround,
      turnaroundMultiplier: state.turnaroundMultiplier,
      finish: selectedFinish
    };
  }

  function resolveCustomerPricing(input, contract) {
    var pricing = input && input.pricing;
    var resolution = resolve(input, contract);
    var pieces = Number(resolution.pieces);
    if (!pricing || !positiveInteger(pieces)) {
      throw new Error('Shared Sticker customer pricing input is invalid.');
    }

    return {
      total: resolution.nativeTotalCents / 100,
      unitPrice: resolution.nativeTotalCents / 100 / pieces,
      quantity: pieces,
      areaSqIn: Number(pricing.area_in2),
      v2: pricing,
      sharedActivation: input.activation || null,
      sharedNative: resolution,
      legacyV2TotalCents: resolution.currentV2TotalCents
    };
  }

  function resolveRepresentedTotal(input, contract) {
    input = input || {};
    var pricing = input.pricing;
    var productId = Number(input.productId || input.activation && input.activation.productId);
    contract = contract || getFamilyContract(productId);
    var targetTotalCents = positiveInteger(input.targetTotalCents);
    var pieces = positiveInteger(pricing && (pricing.qty_entered || pricing.quantity));
    if (!contract || contract.strategy !== FAMILY_STRATEGY || !pricing ||
        !targetTotalCents || !pieces) {
      throw new Error('Products 2.0 native-rate pricing input is invalid.');
    }

    var mappingsByRate = rateMap(contract);
    var candidates = Object.keys(mappingsByRate).map(function (rateCents) {
      var mapping = mappingsByRate[rateCents];
      var encodedQuantity = Math.max(1, Math.round(targetTotalCents / mapping.rateCents));
      return {
        rateCents: mapping.rateCents,
        variantId: mapping.variantId,
        sku: mapping.sku,
        encodedQuantity: encodedQuantity,
        nativeTotalCents: mapping.rateCents * encodedQuantity,
        differenceFromV2Cents:
          mapping.rateCents * encodedQuantity - targetTotalCents
      };
    }).filter(function (candidate) {
      return candidate.encodedQuantity <= contract.maximumEncodedQuantity &&
        (!contract.exactRepresentationsOnly ||
          candidate.differenceFromV2Cents === 0);
    });
    candidates.sort(function (left, right) {
      var error = Math.abs(left.differenceFromV2Cents) -
        Math.abs(right.differenceFromV2Cents);
      if (error !== 0) return error;
      if (left.rateCents !== right.rateCents) return right.rateCents - left.rateCents;
      return left.encodedQuantity - right.encodedQuantity;
    });
    var selected = candidates[0];
    if (!selected || !positiveInteger(selected.encodedQuantity) ||
        selected.nativeTotalCents !== selected.rateCents * selected.encodedQuantity) {
      throw new Error('Products 2.0 native-rate total cannot be represented safely.');
    }

    return {
      profileKey: contract.profileKey,
      family: contract.family,
      strategy: contract.strategy,
      contractVersion: contract.version,
      carrierProductId: contract.carrierProductId,
      sourceProductId: contract.sourceProductId,
      variantId: selected.variantId,
      sku: selected.sku,
      rateCents: selected.rateCents,
      encodedQuantity: selected.encodedQuantity,
      nativeTotalCents: selected.nativeTotalCents,
      currentV2TotalCents: targetTotalCents,
      differenceFromV2Cents: selected.differenceFromV2Cents,
      pieces: pieces,
      sizeTierIn2: Number(pricing.area_in2),
      turnaround: String(pricing.rush_option || 'regular'),
      turnaroundMultiplier: Number(pricing.rush_mult || 1),
      finish: input.finish == null ? '' : String(input.finish)
    };
  }

  function resolveFamilyCustomerPricing(input, contract) {
    var pricing = input && input.pricing;
    var resolution = resolveRepresentedTotal(input, contract);
    if (!pricing) throw new Error('Products 2.0 customer pricing input is invalid.');
    return {
      total: resolution.nativeTotalCents / 100,
      unitPrice: resolution.nativeTotalCents / 100 / resolution.pieces,
      quantity: resolution.pieces,
      areaSqIn: Number(pricing.area_in2),
      v2: pricing,
      sharedActivation: input.activation || null,
      sharedNative: resolution,
      legacyV2TotalCents: resolution.currentV2TotalCents
    };
  }

  function contractForResolution(resolution) {
    if (resolution && resolution.family) {
      return getFamilyContract(resolution.sourceProductId || resolution.carrierProductId);
    }
    return getContract(resolution && resolution.profileKey);
  }

  function buildLine(input, contract) {
    var resolution = input && input.resolution;
    contract = contract || contractForResolution(resolution);
    var uid = String(input && input.uid || '').trim();
    var properties = copyProperties(input && input.properties);
    if (!contract || !resolution || !uid ||
        resolution.contractVersion !== contract.version ||
        !positiveInteger(resolution.variantId) ||
        !positiveInteger(resolution.encodedQuantity)) {
      throw new Error('Invalid shared Sticker production line contract.');
    }

    var artwork = input.artwork || {};
    var proofPreview = String(
      artwork.previewUrl || properties._proof_preview ||
      properties._dcf_preview_url || properties['Proof Preview'] || ''
    ).trim();
    var originalArtwork = String(
      artwork.originalUrl || properties._original_artwork ||
      properties._artwork_original_url || properties['Original Artwork'] || ''
    ).trim();
    delete properties.Product;
    delete properties.calc_line_uid;
    if (contract.family === 'sticker_sheets') {
      delete properties['Artwork Files'];
    }
    delete properties['Proof Preview'];
    delete properties['Job ID'];
    delete properties['Original Artwork'];
    delete properties._pricing_engine;
    delete properties._line_type;
    delete properties._upload_id;
    delete properties._artwork_mode;
    delete properties._artwork_approved;
    delete properties._artwork_original_url;
    delete properties._dcf_preview_url;
    delete properties._calc_data;
    delete properties._job_id;
    delete properties._carrier_strategy;
    delete properties._carrier_contract;
    delete properties._carrier_profile;
    delete properties._carrier_source_product_id;
    delete properties._bundle_quantity_locked;
    delete properties._bundle_display_quantity;
    delete properties._original_artwork;
    delete properties._proof_preview;

    // Static Cling production behavior is fully represented by the visible
    // Material/Finish and Application Side fields before this Cart boundary.
    // These values are consumed only by the pre-add preview workflow; no Cart,
    // rollback, thumbnail, or artwork-retrieval reader uses their raw state.
    if (contract.profileKey === 'white_static_cling' ||
        contract.profileKey === 'clear_static_cling') {
      [
        '_print_orientation',
        '_white_ink',
        '_white_ink_instruction',
        '_mirror_reverse_instruction',
        '_white_base',
        '_preview_template',
        '_preview_transform',
        '_placement_state'
      ].forEach(function (key) {
        delete properties[key];
      });
    }

    // Temporary Tattoo preview placement is consumed before add-to-cart only.
    // Cart, rollback, thumbnail, and artwork retrieval use the normalized
    // artwork aliases below, so these raw preview fields must not reach Admin.
    if (contract.family === 'temp_tattoos') {
      [
        '_preview_template',
        '_preview_transform',
        '_placement_state'
      ].forEach(function (key) {
        delete properties[key];
      });
    }

    // The UID is the one non-artwork private value the one-line Cart contract
    // still needs: it prevents identical configurations from merging and lets
    // the post-add verifier identify exactly the line it may roll back.
    properties._calc_line_uid = uid;
    if (!properties.Finish && (resolution.finish || contract.finish)) {
      properties.Finish = resolution.finish || contract.finish;
    }

    if (originalArtwork) {
      properties._original_artwork = originalArtwork;
    }
    if (proofPreview) {
      properties._proof_preview = proofPreview;
    }

    return {
      id: resolution.variantId,
      quantity: resolution.encodedQuantity,
      properties: properties
    };
  }

  function validateCart(cart, input) {
    var resolution = input.resolution;
    var contract = contractForResolution(resolution);
    var uid = String(input.uid || '');
    var bogo = input && input.bogo;
    var paidPieces = positiveInteger(bogo && bogo.paidPieces);
    var freePieces = positiveInteger(bogo && bogo.freePieces);
    var totalPieces = positiveInteger(bogo && bogo.totalPieces);
    var bogoValid = !bogo || (
      paidPieces === Number(resolution.pieces) &&
      freePieces === paidPieces &&
      totalPieces === paidPieces + freePieces
    );
    var expectedPieces = bogoValid && bogo ? totalPieces : Number(resolution.pieces);
    var lines = (cart && cart.items || []).filter(function (item) {
      return item.properties && item.properties._calc_line_uid === uid;
    });
    var line = lines[0];
    var properties = line && line.properties || {};
    var productionQuantityMatches = bogo
      ? properties['Total Pieces'] === String(expectedPieces)
      : properties.Pieces === String(expectedPieces);
    var valid = !!contract && lines.length === 1 &&
      bogoValid &&
      Number(line.id) === Number(resolution.variantId) &&
      Number(line.quantity) === Number(resolution.encodedQuantity) &&
      Number(line.final_line_price) === Number(resolution.nativeTotalCents) &&
      productionQuantityMatches &&
      properties._calc_line_uid === uid &&
      !Object.prototype.hasOwnProperty.call(properties, 'Product') &&
      !Object.prototype.hasOwnProperty.call(properties, 'Proof Preview') &&
      !Object.prototype.hasOwnProperty.call(properties, 'Job ID') &&
      !Object.prototype.hasOwnProperty.call(properties, 'Original Artwork') &&
      !Object.prototype.hasOwnProperty.call(properties, '_calc_data') &&
      !Object.prototype.hasOwnProperty.call(properties, '_carrier_strategy') &&
      !Object.prototype.hasOwnProperty.call(properties, '_carrier_contract') &&
      !Object.prototype.hasOwnProperty.call(properties, '_carrier_profile') &&
      !Object.prototype.hasOwnProperty.call(properties, '_carrier_source_product_id');

    if (valid && bogo) {
      valid = !Object.prototype.hasOwnProperty.call(properties, 'Pieces') &&
        properties['Paid Pieces'] === String(paidPieces) &&
        properties['_bogo_free_pieces'] === String(freePieces) &&
        properties['Total Pieces'] === String(totalPieces);
    }

    if (valid && contract.family === 'sticker_sheets') {
      var artworkCount = Object.keys(properties).filter(function (key) {
        return /^Artwork \d+$/.test(key) && properties[key];
      }).length;
      var forbiddenStickerSheetProperties = [
        'Shape', 'Easy Peel Tab', 'Artwork Files', 'Proof Preview',
        '_dcf_preview_url'
      ];
      valid = artworkCount === Number(input.stickerSheetArtworkCount || 0) &&
        !forbiddenStickerSheetProperties.some(function (key) {
          return Object.prototype.hasOwnProperty.call(properties, key);
        });
    }

    return {
      valid: valid,
      line: line || null,
      lineCount: lines.length,
      actualTotalCents: line ? Number(line.final_line_price) : 0
    };
  }

  function verifyOrRollback(cart, input, rollback) {
    var result = validateCart(cart, input);
    if (result.valid) return Promise.resolve(result);
    console.error('[ZUG][SHARED_STICKER] Cart verification failed.', result);
    return Promise.resolve()
      .then(rollback)
      .then(function () {
        throw new Error('Shared Sticker production cart verification failed; line rolled back.');
      });
  }

  return {
    STRATEGY: STRATEGY,
    CONTRACT_VERSION: CONTRACT_VERSION,
    ACTIVE_MODE: ACTIVE_MODE,
    ROLLBACK_MODE: ROLLBACK_MODE,
    LAUNCH_DEFERRED_MODE: LAUNCH_DEFERRED_MODE,
    CONTRACT: CONTRACT,
    DIE_CUT_CONTRACT: DIE_CUT_CONTRACT,
    MATTE_CONTRACT: MATTE_CONTRACT,
    CLEAR_CONTRACT: CLEAR_CONTRACT,
    HOLOGRAPHIC_CONTRACT: HOLOGRAPHIC_CONTRACT,
    CHROME_CONTRACT: CHROME_CONTRACT,
    SPOT_UV_CONTRACT: SPOT_UV_CONTRACT,
    WHITE_STATIC_CLING_CONTRACT: WHITE_STATIC_CLING_CONTRACT,
    CLEAR_STATIC_CLING_CONTRACT: CLEAR_STATIC_CLING_CONTRACT,
    PROFILE_CONTRACTS: PROFILE_CONTRACTS,
    EXPECTED_RATE_COUNT: EXPECTED_RATE_COUNT,
    configureCatalog: configureCatalog,
    configureFamilyCatalog: configureFamilyCatalog,
    getContract: getContract,
    getFamilyContract: getFamilyContract,
    clearCatalogForTest: clearCatalogForTest,
    clearFamilyCatalogsForTest: clearFamilyCatalogsForTest,
    classify: classify,
    classifyFamily: classifyFamily,
    resolve: resolve,
    resolveCustomerPricing: resolveCustomerPricing,
    resolveRepresentedTotal: resolveRepresentedTotal,
    resolveFamilyCustomerPricing: resolveFamilyCustomerPricing,
    buildLine: buildLine,
    validateCart: validateCart,
    verifyOrRollback: verifyOrRollback
  };
});
